

<section class="time-filter-wrap" [class.scroll]="!showSearchMobile">
    <!-- <div class="live-link search">
        <div class="search-button btn primary small icon icon-magnifier" [class.moved]="showSearchMobile" (click)="toggleShowSearchMobile()"></div>
        <div class="overlay blur" [class.show]="showSearchMobile" (click)="showHideSearchMobile(false)"></div>
        <app-search-events [class.show]="showSearchMobile" [isLive]="pageType === pageTypeEnum.Live ? true : false"></app-search-events>
    </div> -->
    <div class="live-link" [class.selected]="timeFilterValue == timeFilterValueEnum.Live" (click)="timeFilterValueChange(timeFilterValueEnum.Live, pageTypeEnum.Live)">
        <div class="sorting">
            <h1>{{pageTypeEnum[pageType]}}</h1>
            <span [class.active]="orderByCompetition && timeFilterValue == timeFilterValueEnum.Live"></span>
            <span [class.active]="!orderByCompetition && timeFilterValue == timeFilterValueEnum.Live"></span>
        </div>
        <span >UŽIVO</span>
        <span class="empty"></span>
    </div>
    <div class="time-option-wrap">
        <div class="time-option today" [class.selected]="timeFilterValue == timeFilterValueEnum.Today" (click)="timeFilterValueChange(timeFilterValueEnum.Today, pageTypeEnum.Prematch)">
            <span class="day" i18n="Sport tree radio date range Today@@SportTreeToday">DANAS</span>
            <span>{{today | date:'dd.MM.'}}</span>
        </div>
        <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.D1" (click)="timeFilterValueChange(timeFilterValueEnum.D1, pageTypeEnum.Prematch)">
            <span class="day">{{D1 | date:'E'}}</span>
            <span>{{D1 | date:'dd.MM.'}}</span>
        </div>
        <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.D2" (click)="timeFilterValueChange(timeFilterValueEnum.D2, pageTypeEnum.Prematch)">
            <span class="day">{{D2 | date:'E'}}</span>
            <span>{{D2 | date:'dd.MM.'}}</span>
        </div>
        <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.D3" (click)="timeFilterValueChange(timeFilterValueEnum.D3, pageTypeEnum.Prematch)">
            <span class="day">{{D3 | date:'E'}}</span>
            <span>{{D3 | date:'dd.MM.'}}</span>
        </div>
        <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.D4" (click)="timeFilterValueChange(timeFilterValueEnum.D4, pageTypeEnum.Prematch)">
            <span class="day">{{D4 | date:'E'}}</span>
            <span>{{D4 | date:'dd.MM.'}}</span>
        </div>
        <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.D5" (click)="timeFilterValueChange(timeFilterValueEnum.D5, pageTypeEnum.Prematch)">
            <span class="day">{{D5 | date:'E'}}</span>
            <span>{{D5 | date:'dd.MM.'}}</span>
        </div>
        <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.D6" (click)="timeFilterValueChange(timeFilterValueEnum.D6, pageTypeEnum.Prematch)">
          <span class="day">{{D6 | date:'E'}}</span>
          <span>{{D6 | date:'dd.MM.'}}</span>
        </div>
        <div class="time-option" [class.selected]="timeFilterValue == timeFilterValueEnum.All" (click)="timeFilterValueChange(timeFilterValueEnum.All, pageTypeEnum.Prematch)">
            <span class="day" i18n="Sport tree radio date range All radio and checkbox@@SportTreeAll">SVE</span>
            <span class="empty"></span>
        </div>
    </div>
    <app-results-filter [pageType]="pageType" (filterValue)="selectResultsTimeFilter($event)"></app-results-filter>

</section>
<!-- 
<div class="filter-search-wrap">
    <div class="search">
        <app-search-events [class.show]="showSearchMobile" [isLive]="pageType === pageTypeEnum.Live ? true : false"></app-search-events>
    </div>
</div> -->
